
define(
	'Jeske.PLPBrandName.PLPModule'
,   [
		'Jeske.PLPBrandName.PLPModule.View'
	]
,   function (
		PLPModuleView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
        {
            var PLP = container.getComponent('PLP');
            if(PLP)
				{
					PLP.addChildView('ItemViews.Brand', function() {
                        return new PLPModuleView({
                            PLP: PLP,
                            container: container
                        });
                    });
				}
        }
	};
});
